import { useSidebarState } from '@/features/workspace/hooks';
import { InternalSidebar } from '@/internal/app/internal-sidebar';
import { MotionDiv } from '@/shared/components/motion-div';
import { SidebarInset, SidebarProvider } from '@/shared/components/shadcn/sidebar';

export const InternalWorkspaceLayout = ({ children }: { children: React.ReactNode }) => {
  const { isCollapsed, setCollapsed } = useSidebarState();
  return (
    <MotionDiv>
      <SidebarProvider open={!isCollapsed} onOpenChange={(open) => setCollapsed(!open)}>
        <InternalSidebar />
        <SidebarInset className="flex h-[calc(100vh)] flex-1 flex-col gap-2 overflow-auto">
          {children}
        </SidebarInset>
      </SidebarProvider>
    </MotionDiv>
  );
};
